import {Modal, List} from "antd";
import {WorkOrderLog} from "../../../../../../../store/data/entities/work-order-log";
import {useMemo} from "react";
import {DateTime} from "luxon";
import {humanizeDate} from "../../../../../../../utils/humanizers";

interface WorkLogEntryHistoryModalProps {
  open: boolean;
  onClose: () => void;
  workOrderLog: WorkOrderLog | undefined;
}

export default function WorkLogEntryHistoryModal(props: WorkLogEntryHistoryModalProps) {
  const previousComments = useMemo(() => {
    if (!props.open || !props.workOrderLog) return [];
    const items = Object.entries(props.workOrderLog.previousComments || {})
      .map(([date, comments]) => ({
        date: DateTime.fromISO(date),
        comments
      }))
      .sort((a, b) => b.date.toMillis() - a.date.toMillis());

    return [
      {
        date: DateTime.fromISO(props.workOrderLog.createdOn),
        comments: props.workOrderLog.comments,
        isCurrent: true,
      },
      ...items
    ];
  }, [props.workOrderLog])
  
  return (
    <Modal
      title='Work Log History'
      open={props.open}
      onClose={props.onClose}
      cancelButtonProps={{style: {display: 'none'}}}
      onOk={props.onClose}
      okText='Close'
    >
      <List
        size="large"
        bordered
        dataSource={previousComments}
        renderItem={(item) => (
          <List.Item>
            <List.Item.Meta
              title={humanizeDate(item.date.toISO(), true)}
              description={item.comments}
            />
          </List.Item>
        )}
      />
    </Modal>
  )
}
